function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "image"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m19 4h-14c-1.654 0-3 1.346-3 3v10c0 1.654 1.346 3 3 3h14c1.654 0 3-1.346 3-3v-10c0-1.654-1.346-3-3-3zm-14 2h14c.551 0 1 .448 1 1v6.864l-2.823-2.353c-1.234-1.028-3.163-.939-4.298.195l-2.879 2.88-.879-.879c-1.17-1.17-3.072-1.17-4.242 0l-.879.879v-7.586c0-.552.449-1 1-1zm14 12h-14c-.429 0-.789-.274-.93-.655l2.223-2.224c.39-.389 1.024-.389 1.414 0l1.586 1.586c.391.391 1.023.391 1.414 0l3.586-3.586c.409-.409 1.158-.443 1.604-.072l4.103 3.42v.531c0 .552-.449 1-1 1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m7.5 12c1.378 0 2.5-1.121 2.5-2.5s-1.122-2.5-2.5-2.5-2.5 1.121-2.5 2.5 1.122 2.5 2.5 2.5zm0-3c.276 0 .5.225.5.5s-.224.5-.5.5-.5-.225-.5-.5.224-.5.5-.5z"
})));

var Svg055Image = function Svg055Image(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg055Image, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/055-image.07977cbf.svg";
export { ForwardRef as ReactComponent };